import { render } from "./PathwaySharedToUser.vue?vue&type=template&id=fe66ec66"
import script from "./PathwaySharedToUser.vue?vue&type=script&lang=js"
export * from "./PathwaySharedToUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__